module.exports = __webpack_public_path__ + "static/Dyer-78-5ad671591622357f126c149410ce3c02.jpeg";